module.exports = __webpack_public_path__ + "media/images/facebook-e29478b6f5d6db575d176313c3a33024.png";